import { FC } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { getAdminState } from 'src/store/admin/selectors';

export const AdministratorTownSidesheetTitle: FC = () => {
  const { selectedTownId } = useSelector(getAdminState);

  return (
    <Typography variant='h5' data-testid='administratorSideSheetTitle'>
      {selectedTownId ? 'Редактирование города' : 'Создание города'}
    </Typography>
  );
};
